// extracted by mini-css-extract-plugin
module.exports = {"card":"card--l1amo","body":"body--3CucF"};